<template>
  <div class="sider-list-1" ref="sider">
    <div class="sider-title">{{ title }} <b class="fr mainCol textUnderLine cp" @click="showV">使用教程</b></div>
    <ul class="list-1" >
      <li v-for="(item, index) in $PAGE_API.home.children.securityCenter.children
      .index.children" :key="index"   :id="item.id" v-if="item.title != 'DLL注入'">
        <!-- 我的安全规则 -->
        <template  v-if="item.title == '安全中心客户端下载'">
          <router-link   :to="item.path" v-if=" $store.state.user.isCanUseClient">
            <span v-text="item.title"></span>
          </router-link>
        </template>
        <router-link :to="item.path" v-else-if="item.title != '规则大厅' && item.title !='DLL注入' && item.title !='开机通道' ">
          <span v-text="item.title"></span>
        </router-link>
        <template v-else>
          <template  class="v-step-1" v-if="item.title == '规则大厅'">
            <router-link :to="item.path" :disabled="!$store.state.user.isCanUseClient">
              <span>{{ item.title
              }}<b v-if="!$store.state.user.isCanUseClient">(公测中)</b></span>
            </router-link>
          </template>
          <template v-else-if="item.title == 'DLL注入'">
            <router-link :to="item.path" :disabled="!$store.state.user.isShowDll">
              <span>{{ item.title
              }}<b v-if="!$store.state.user.isShowDll">(公测中)</b></span>
            </router-link>
          </template>
          <template v-else-if="item.title == '开机通道'">
            <router-link :to="item.path" :disabled="!$store.state.user.isShowDll">
              <span>{{ item.title
              }}<b v-if="!$store.state.user.isShowDll">(公测中)</b></span>
            </router-link>
          </template>
        </template>
      </li>
      <!-- <li v-for="(item, index) in $PAGE_API.home.children.aloneClient.children
      .index.children" :key="index" v-show="index == 0">
        <router-link :to="item.path">
          <span v-text="item.title"></span>
        </router-link>
      </li> -->
    </ul>
    <!-- <div
      v-if="$store.state.user.isCanUseClient"
      class="sider-title"
      v-text="$PAGE_API.home.children.aloneClient.title"
    ></div> -->
    <!-- <ul class="list-1" v-if="$store.state.user.isCanUseClient">
      <li v-for="(item, index) in $PAGE_API.home.children.aloneClient.children
      .index.children" :key="index" v-if="index == 0">
        <router-link :to="item.path">
          <span v-text="item.title"></span>
        </router-link>
      </li>
    </ul> -->
    <!-- <v-tour name="myTour"  :options="myOptions">
      <v-step v-if="currentStep === index"
        v-for="(step, index) of steps"
        :key="index"
        :step="step"
      >
        {{ step.content }}
      </v-step>
    </v-tour> -->
    <v-tour name="myTour" :steps="steps" :options="myOptions" >
        <template slot-scope="tour">
            <transition name="fade">
              <div class="maskImgCon pf pr" v-if="isShow">
                <i class="closeIncon f30 fw pa cp closeIncon2" @click="closeFn">x</i>
                <img :src="src" alt="" class="pa center">
              </div>
                <v-step
                    v-if="tour.currentStep === index"
                    v-for="(step, index) of tour.steps"
                    :key="index"
                    :step="step"
                    :previous-step="tour.previousStep"
                    :next-step="tour.nextStep"
                    :stop="tour.stop"
                    :is-first="tour.isFirst"
                    :is-last="tour.isLast"
                    :labels="tour.labels"
                    :highlight="tour.highlight"
                >
                   <template v-if="tour.currentStep === 0">
                        <div slot="content" class="tal stepCon">
                              <i class="closeIncon f30 fw pa cp" @click="closeFn2(tour.stop())">x</i>
                              <div class="f18 fw"><b class="f12">1</b>下载客户端</div>
                              <div class="margin10 clearfix" style="width: 100%;">
                                <div class="fl">
                                  <img src="../../../assets/guid/1.png"  alt="" />
                                </div>
                                <div class="fl">
                                  <h3 class="fw f14 tal">下载解压后</h3>
                                  <img src="../../../assets/guid/11.png" width="440" style="margin-top: 20px;" alt=""></img>
                                </div>
                              </div>
                              <p class="f18 fw"><b class="f12">2</b>安装客户端</p>
                              <div class="f16 fw margin10">2.1  挂盘安装 <span class="errorCol">【推荐】</span></div>
                              <div class="margin10 clearfix" >
                                <h3 class=" f14 tal fw">启动解压后文件中的 <span class="mainCol">【独立版挂盘启动部署工具】</span><span class="errorCol">右键管理员运行</span></h3>
                                <Row :gutter="16" class="margin10">
                                    <Col span="12 ">
                                      <Card class="tal">
                                            <p slot="title" class="f14 fw">方式1.在服务器上运行</p>
                                            <div class="pr">
                                              <img src="../../../assets/guid/21.gif" width="300px" alt=""></img>
                                              <Button  type="primary"  class=" pa center" @click="lookFn(1)">查看大图</Button>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col span="12">
                                      <Card class="tal">
                                            <p slot="title" class="f14 fw">方式2.在客户机上超级用户状态</p>
                                            <div class="pr">
                                              <img src="../../../assets/guid/21.gif" width="300px" alt=""></img>
                                              <Button type="primary" class=" pa center" @click="lookFn(2)">查看大图</Button>
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>
                              </div>
                              <div class="f16 fw margin10">2.2  开机启动</div>
                              <p class="margin10">
                                下载后可使用各种开机命令/其他软件调用/开机文件夹等方式实现开机启动，程序启动后仅有1个常驻进程，无任何界面，资源占用极低
                              </p>
                        </div>
                        <div slot="actions" class="tar">
                            <Button @click="tour.nextStep" type="primary" class="btn btn-primary marginleft10">下一步</Button>
                            <Button @click="tour.stop" type="warning" class="btn btn-primary marginleft10">跳过</Button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 1">
                        <div slot="content"  class="tal stepCon">
                          <div class="f18 fw"><b class="f12">3</b>部署完成，并重启客户端生效</div>
                          <p class="f14">【改名】【删除】网吧、【防护开关】、【开机通道开关】、客户端管理、【开机通道任务管理】、【查看日志路径】</p>

                          <div class="pr">
                            <img src="../../../assets/guid/23.gif" width="80%" alt=""></img>
                            <Button  type="primary"  class=" pa center" @click="lookFn(3)">查看大图</Button>
                          </div>
                        </div>
                        <div slot="actions" class="tar">
                            <Button @click="tour.previousStep" type="primary" class="btn btn-primary marginleft10">上一步</Button>
                            <Button @click="tour.nextStep" type="primary" class="btn btn-primary marginleft10">下一步</Button>
                            <Button @click="tour.stop"  type="warning" class="btn btn-primary marginleft10">跳过</Button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 2">
                      <div slot="content"  class="tal stepCon">
                          <div class="f18 fw"><b class="f12">4</b>复制共享规则到我的规则库</div>
                          <p class="f14">【复制规则】到我的安全规则，选择需要的规则，点击复制到我的规则库</p>
                          <div class="pr">
                            <img src="../../../assets/guid/24.gif" width="80%" alt=""></img>
                            <Button  type="primary"  class=" pa center" @click="lookFn(4)">查看大图</Button>
                          </div>
                          <div class="f18 fw"><b class="f12">5</b>复制并启用</div>
                          <p class="f14">复制规则并应用到安全组，可以在规则分组进行分组</p>
                        </div>
                        <div slot="actions" class="tar">
                            <Button @click="tour.previousStep" type="primary" class="btn btn-primary marginleft10">上一步</Button>
                            <Button @click="tour.nextStep" type="primary" class="btn btn-primary marginleft10">下一步</Button>
                            <Button @click="tour.stop"  type="warning" class="btn btn-primary marginleft10">跳过</Button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 3">
                      <div slot="content"  class="tal stepCon">
                          <div class="f18 fw"><b class="f12">6</b>规则分组管理</div>
                          <p class="f14">【新建】【编辑】【删除】规则分组、【分配网吧】到规则分组、【分配规则】到规则分组</p>
                          <div class="pr">
                            <img src="../../../assets/guid/26.gif" width="80%" alt=""></img>
                            <Button  type="primary"  class=" pa center" @click="lookFn(6)">查看大图</Button>
                          </div>
                        </div>
                        <div slot="actions" class="tar">
                            <Button @click="tour.previousStep" type="primary" class="btn btn-primary marginleft10">上一步</Button>
                            <Button @click="tour.nextStep" type="primary" class="btn btn-primary marginleft10">下一步</Button>
                            <Button @click="tour.stop"  type="warning" class="btn btn-primary marginleft10">跳过</Button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 4">
                      <div slot="content"  class="tal stepCon">
                          <div class="f18 fw"><b class="f12">7</b>我的安全规则</div>
                          <p class="f14">【新建】【编辑】【删除】规则、【升级】共享规则、【分配规则】到规则分组</p>
                          <div class="pr">
                            <img src="../../../assets/guid/25.gif" width="80%" alt=""></img>
                            <Button  type="primary"  class=" pa center" @click="lookFn(5)">查看大图</Button>
                          </div>
                        </div>
                        <div slot="actions" class="tar">
                            <Button @click="tour.previousStep" type="primary" class="btn btn-primary marginleft10">上一步</Button>
                            <Button @click="tour.stop"  type="warning"  class="btn btn-primary marginleft10">完成</Button>
                        </div>
                    </template>
                </v-step>
            </transition>
        </template>
    </v-tour>
  </div>
</template>

<script>
import img1 from '../../../assets/guid/21.gif'
import img2 from '../../../assets/guid/22.gif'
import img3 from '../../../assets/guid/23.gif'
import img4 from '../../../assets/guid/24.gif'
import img5 from '../../../assets/guid/25.gif'
import img6 from '../../../assets/guid/26.gif'
import {queryAgreementSecurity} from '../../../requests/agreement'
export default {
  data () {
    return {
      isShow: false,
      title: '安全中心',
      title2: '安全中心客户端管理',
      steps: [
        {
          target: '#v-step-0', // We're using document.querySelector() under the hood
          content: 'Discover <strong>Vue Tour</strong>!',
          params: {
            placement: 'left',
            highlight: true // 不显示
          }
        },
        {
          target: '#v-step-1',
          content: 'An awesome plugin made with Vue.js!',
          params: {
            placement: 'left',
            highlight: true // 不显示
          }
        },
        {
          target: '#v-step-2',
          content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
          params: {
            placement: 'left',
            highlight: true // 不显示
          }
        },
        {
          target: '#v-step-3',
          content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
          params: {
            placement: 'left',
            highlight: true // 不显示
          }
        },
        {
          target: '#v-step-4',
          content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.',
          params: {
            placement: 'left',
            highlight: true // 不显示
          }
        }
      ],
      currentStep: 0,
      highlight: true,
      myOptions: {
        useKeyboardNavigation: false, // 不使用←、→和ESC键来导航tour
        highlight: true,
        labels: {
          buttonSkip: '跳过',
          buttonPrevious: '上一步',
          buttonNext: '下一步',
          buttonStop: '关闭'
        }
      },
      src: img1
    }
  },
  mounted () {
    // if (this.$store.state.user.isCanUseClient) {
    //   if (window.localStorage.getItem('isClose') != 1) { this.$tours['myTour'].start() }
    // }
  },
  methods: {
    closeFn2() {
      window.localStorage.setItem('isClose', 1)
    },
    showV() {
      this.currentStep = 1
      this.$tours['myTour'].start(1)
    },
    closeFn() {
      this.isShow = false
    },
    lookFn(val) {
      switch (val) {
        case 1:
          this.src = img1
          break;
        case 2:
          this.src = img2
          break;
        case 3:
          this.src = img3
          break;
        case 4:
          this.src = img4
          break;
        case 5:
          this.src = img5
          break;
        case 6:
          this.src = img6
          break;
        default:
          break;
      }
      this.isShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
.sider-list-1 {
  width: 200px;
  position: absolute;
  top: 0;
  bottom: 0;
  background: #eaedf1;
  text-align: left;
  text-indent: 20px;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
}

.sider-title {
  height: 70px;
  line-height: 70px;
  background: #d9dee4;
  font-size: 14px;
  font-weight: 600;
}

.list-1 {
  padding-top: 10px;
  padding-bottom: 10px;

  li {
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    overflow: hidden;

    a {
      display: block;
      color: #333;
      padding-right: 10px;
      transition: all 0.3s;

      &:hover {
        background: #fff;
      }

      &.router-link-active {
        background: #fff;
      }

      >span {
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-indent: 0px;
      }

      >div {
        float: right;
        max-width: 70px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}

.list-1 {
  padding-bottom: 5px;
}
</style>
<style lang="scss">
.maskImgCon{
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,10);
  img{
    width:  90%;
  }
}
.v-tour__target--highlighted {
    box-shadow: 0 0 0 99999px rgba(0,0,0,.4);
}
.v-step{
  width: 900px !important;
  max-width: none !important;
  background: #fff !important;
}
.list-1 li a{
  height: 40px;
}
.sider-list-1{
  overflow: unset !important;
  overflow-x: unset !important;
}
.v-step__arrow::before{
  /* margin-left: -125px !important;
  transform: rotate(130deg) !important;
  margin-top: -36px !important; */
  margin-left: -25px !important;
}
.stepCon{
  color: #000;
  b{
    width: 20px;
    height: 20px;
    background: #000;
    color: #fff;
    border-radius: 50px;
    display: inline-block;
    line-height: 20px;
    text-indent:6px !important;
    margin-right: 10px;
  }
 .f18{
    margin-top: 10px;
  }
  .ivu-card-head{
    padding:  10px;
    p{
      text-indent: 0;
    }
  }
  .ivu-card-body{
    padding: 0;
  }
}
.margin10{
  margin: 10px;
}
.marginleft10{
  margin-left: 10px;
}
.closeIncon{
  right: 30px;
  background: #fff;
  &.closeIncon2{
    right: 10%;
    top: 10%;
    z-index: 9999;
    text-align: center;
    background: #000;
    text-indent:0;
    width: 60px;
    height: 60px;
    color: #0066CC;
    border-radius: 50px;
    line-height: 60px;

  }
}
.textUnderLine{
  margin-right: 10px;
  text-decoration: underline;
}
</style>
